import { DataGridPro } from "@mui/x-data-grid-pro";
import CustomToolbar from "./CustomToolbar";

const defaultPageSize = 40
// checkboxSelection (opcional): habilita seleção múltipla via checkboxes.
// Quando ligado, o disableMultipleSelection padrão é desativado automaticamente.
// Telas que não passam a prop mantêm o comportamento atual (seleção única por linha).
export function SL_Grid({ rows, columns, onRowClick, checkboxSelection = false, ...rest }) {
    return (
        <DataGridPro
            rows={rows}
            columns={columns}
            onRowClick={onRowClick}
            pagination
            pageSize={defaultPageSize}
            rowsPerPageOptions={[defaultPageSize]}
            components={{
                Toolbar: () => <CustomToolbar />,
            }}
            density="compact"
            checkboxSelection={checkboxSelection}
            disableMultipleSelection={!checkboxSelection}

            {...rest}
        />
    )
}